import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Inbound")
  ])
], -1)
const _hoisted_5 = { class: "col-md-12 col-lg-12 my-1" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "text-muted h5 font-weight-normal mr-3"
}, "Greeting", -1)
const _hoisted_8 = { class: "row mt-2 w-100" }
const _hoisted_9 = { class: "col-12 col-sm-8 col-md-8 col-lg-8 col-xl-9 my-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_11 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3 mt-2" }
const _hoisted_12 = { class: "d-flex flex-row" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Reset ")

import { ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { Form, FormActions, Field } from "vee-validate";
import { CircleCloseFilled, List, WarningFilled } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { dialerApi } from "@/conection/index";
import { formatNumber } from "@/util/utils.ts";

import * as yup from "yup";

enum sendType {
	CALL = "call",
	SMS = "sms",
	WA = "wha",
}
//schema

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
const loadingCall = ref(false);
const loadingSMS = ref(false);
const loadingWA = ref(false);
const schema = yup.object({
	message: yup.string().required("Message is required"),
	number1: yup.string().matches(/[0-9]{3,}/, "Phone number is not valid"),
});
async function onSubmit(values: any, type: string) {
	switch (type) {
		case sendType.CALL:
			sendCall(values);
			break;

		default:
			break;
	}
}
async function sendCall(values: any) {
	loadingCall.value = true;
	try {
		const response = await dialerApi.post("/inbound/config", {
			text: values.message,
			target: {
				number: formatNumber(values.number1),
				context: "llamada_saliente_internacional",
			},
			dtmf_options: {
				ttp: 5000,
				length: 2,
			},
			config: {
				repeat: 1,
				offsetms: 2000,
			},
		});
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Call Redirected successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Call has not been sent`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Call has not been sent`,
			type: "error",
		});
	}

	loadingCall.value = false;
}
async function deleteRoute() {
	loadingCall.value = true;
	try {
		const response = await dialerApi.delete("/inbound/config");
		if (response.status === 200) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Reset successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Reset not completed`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Reset not completed`,
			type: "error",
		});
	}

	loadingCall.value = false;
}
function onInvalidSubmit(values: iInvalidSubmit) {
	console.log(values);

	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100 form-inline",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schema),
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(({ handleSubmit, values }) => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(Field), { name: "message" }, {
                        default: _withCtx(({ field }) => [
                          _hoisted_7,
                          _createElementVNode("textarea", _mergeProps({
                            name: "message",
                            id: "message",
                            class: "form-control col-11",
                            "aria-label": "With textarea",
                            rows: "4"
                          }, field, { alternative: "" }), null, 16)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(BaseInput, {
                        name: "number1",
                        label: "Destination",
                        placeholder: "22505555",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-phone",
                        inputGroupClasses: "w-75",
                        alternative: ""
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_base_button, {
                          disabled: loadingCall.value,
                          "native-type": "submit",
                          onClickCapture: ($event: any) => (
												handleSubmit($event, onSubmit(values, sendType.CALL))
											)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              (!loadingCall.value)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    size: 20,
                                    color: "#FFFFF",
                                    class: "no-inherit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(List))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (loadingCall.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                : _createCommentVNode("", true),
                              _hoisted_15
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClickCapture"]),
                        _createVNode(_component_el_popconfirm, {
                          "confirm-button-text": "Sí",
                          "cancel-button-text": "No",
                          icon: _unref(WarningFilled),
                          "icon-color": "#F0463A",
                          width: "235",
                          "show-after": 0,
                          "hide-after": 0,
                          title: "Are you sure to reset routes?",
                          onConfirm: _cache[0] || (_cache[0] = ($event: any) => (deleteRoute())),
                          "popper-options": { gpuAcceleration: false },
                          teleported: false
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_base_button, {
                              disabled: loadingCall.value,
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  (!loadingCall.value)
                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                        key: 0,
                                        size: 20,
                                        color: "#FFFFF",
                                        class: "no-inherit"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CircleCloseFilled))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (loadingCall.value)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                                    : _createCommentVNode("", true),
                                  _hoisted_18
                                ])
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["icon"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"]))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})